import React from "react";
import { useActiveSessions, ActiveSessionsTableRow } from "pages/dashboard/components/active_sessions";
import { Table } from "react-bootstrap";

export const ActiveSessionsTable = props => {

    const { sessions } = useActiveSessions();

    return (
        <Table>
            <thead>
                <tr>
                    <th>
                        Session State
                    </th>
                    <th>
                        Connection State
                    </th>
                    <th>
                        Product
                    </th>
                    <th>
                        Culture
                    </th>
                    <th>
                        AppStream User
                    </th>
                    <th>
                        Application User
                    </th>
                    <th>
                        CPU
                    </th>
                    <th>
                        Memory
                    </th>
                    <th>
                        Connection
                    </th>
                    <th>
                        Duration
                    </th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {!!sessions?.length ?
                (
                    <>
                        {sessions.map((session, key) => (
                            <ActiveSessionsTableRow session={session} key={key} />
                        ))}
                    </>
                )
                :
                (
                    <tr>
                        <td colSpan={11} className="text-center">
                            No active sessions
                        </td>
                    </tr>
                )
            }
            </tbody>
        </Table>

    );

};